module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SE-4b0f8b5f84a4af72ba9541c55861f333.png";